import { createSelector } from '@ngrx/store'

export const getProfileState = createSelector(
  (state: any) => state.profile,
  (state: any) => state.get('user'),
)

export const getUpdatePasswordState = createSelector(
  (state: any) => state.profile,
  (state: any) => state.get('updatePassword'),
)
